import { configureStore } from '@reduxjs/toolkit'
import RootReducer from 'features/rootReducer'

export default configureStore({
  reducer: RootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware(),
  enhancers: [],
})
